import { h, svgUse } from '../../utils/dom.js';
import { t } from '../../i18n/index.js';

export function EmptyState({ message, icon } = {}) {
  return h('div', { class: 'state-block' },
    icon ? h('div', { class: 'state-icon' }, svgUse(icon)) : null,
    h('p', {}, message || t('emptyTitle'))
  );
}
